import { $host } from "./index";

export const getCourses = async () => {
  const { data } = await $host.get("web/academy/courses/");
  return data.courses;
};

export const getCourseById = async (id) => {
  const { data } = await $host.get(`web/academy/course/${id}`);
  return data.course;
};

export const getLesson = async (id) => {
  const { data } = await $host.get(`web/academy/lesson/${id}`);
  return data.lesson;
};